<template>
  <Wrapper :type="type" @delete="$emit('delete')">
    <v-divider
      slot="preview"
      :style="`border-top-width: ${data.height}px;`"
      :light="data.showDivider"
      :dark="!data.showDivider"
    />
    <v-layout slot="edition">
      <v-flex xs6>
        <v-text-field
          type="number"
          :value="data.height"
          label="Height"
          box
          @input="setValue('height', Number($event))"
        ></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-checkbox
          :input-value="data.showDivider"
          label="Show divider"
          single-line
          @change="setValue('showDivider', $event)"
        ></v-checkbox>
      </v-flex>
    </v-layout>
  </Wrapper>
</template>

<script>
import Wrapper from "../../components/widgets/Wrapper";

export default {
  name: "Separator",
  components: {
    Wrapper
  },
  model: {
    prop: "data"
  },
  props: {
    type: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    setValue(type, value) {
      this.$emit("input", {
        ...this.data,
        [type]: value
      });
    }
  }
};
</script>
